export default "__VITE_ASSET__C6t_PgOH__"